import script from "./EditCourseView.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditCourseView.vue?vue&type=script&lang=ts&setup=true"

import "./EditCourseView.vue?vue&type=style&index=0&id=321ab9d4&lang=scss"

const __exports__ = script;

export default __exports__